/*
 * Click-to-load video.
 *
 * The poster and the button are static HTML; the third-party player is only
 * fetched once the reader asks for it, so a page carrying a film costs nothing
 * until someone wants to watch one.
 *
 * It lives in an asset rather than in a section's own script block, because a
 * section only contributes its script when that section is on the page — and
 * the split band uses this element too, on pages where the video band is not.
 */
(() => {
  class BhaktaVideo extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[data-bk-play]');
      if (!button || !this.dataset.embed) return;
      button.addEventListener('click', () => this.play(), { once: true });
    }

    play() {
      const frame = document.createElement('iframe');
      frame.className = 'bk-video__frame';
      frame.src = this.dataset.embed;
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      frame.title = this.querySelector('.bk-video__heading')?.textContent?.trim() || 'Video';
      this.appendChild(frame);
      this.classList.add('is-playing');
    }
  }

  if (!customElements.get('bhakta-video')) {
    customElements.define('bhakta-video', BhaktaVideo);
  }
})();
